var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"title":_vm.firstName + ' ' + _vm.lastName,"left":_vm.left}},[(_vm.url)?_c('img',{attrs:{"src":_vm.url}}):_c('div',{class:_vm.b('initials'),style:(_vm.initialsStyle)},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }